import HomePage from "./pages/HomePage";

/** @type {import('../types').MobileTenantModule} */
const eds = {
  key: "eds",
  label: "Elite Drive Solutions",
  domains: ["edsdrive.com", "www.edsdrive.com"],
  codePath: "public-web/src/mobile/eds",
  pages: {
    home: HomePage,
    download: HomePage,
  },
};

export default eds;
